import React, { useState } from "react";
import Select from "react-select";
import { centerOptions, doctorOptions } from "../contants/options";
import * as XLSX from "xlsx";
import DoctorTables from "../tables/DoctorTables";
import exportIcon from "../assets/export.svg";
import searchIcon from "../assets/searchicon.svg";

const SurgeyPackage = () => {
  const [filters, setFilters] = useState({
    centers: [],
    doctors: [],
    startDate: "",
    endDate: "",
  });

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Simulated API call
  const fetchData = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/mis-doctor/surgery-package`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          location_id: filters?.centers
            ?.map((center) => center.value)
            .join(","),
          defination: filters?.doctors?.map((doctor) => doctor.value).join(","),
          startDate: filters?.startDate,
          endDate: filters?.endDate,
        }),
      }
    );

    const result = await response.json();
    setData(result);
    // setCurrentPage(1)
    setIsLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const handleExport = () => {
    setIsLoading(true); // Show loading icon

    const modifiedData = data.map((item) => {
      // Create a copy of the original object without the existing keys
      const {
        "Total Net Payable": _,
        Paid: __,
        "Not Paid": ___,
        "Last finanial year": ____,
        CenterId: _____,
        ...cleanedItem
      } = item;

      // Add only the new keys
      return {
        ...cleanedItem,
        "Net Billing": Number(item["Total Net Payable"]) || 0,
        Payable: Number(item["Paid"]) || 0,
        Pending: Number(item["Not Paid"]) || 0,
        // 'Pending 24-25': item['Last finanial year']
      };
    });

    // Function to calculate column widths based on content
    const getColumnWidths = (data) => {
      if (!data.length) return [];

      return Object.keys(data[0]).map((key) => ({
        wch:
          Math.max(
            key.length, // Header length
            ...data.map((row) => (row[key] ? row[key].toString().length : 0)) // Max content length
          ) + 2, // Add padding
      }));
    };

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(modifiedData);
    ws["!cols"] = getColumnWidths(modifiedData); // Set dynamic column widths

    // Create a workbook with the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Write the workbook to a file
    XLSX.writeFile(
      wb,
      `IPD_${filters?.doctors
        ?.map((doctor) => doctor.value)
        .join(",")}-${filters?.centers
        ?.map((center) => center.label)
        .join(",")}-${filters.startDate}-${filters.endDate}_summary.xlsx`
    );

    setIsLoading(false); // Hide loading icon after export
  };

  const handleChange = (selectedOptions) => {
    setFilters((prev) => ({ ...prev, doctors: selectedOptions }));
  };
  const handleChangeCenter = (selectedOptions) => {
    setFilters((prev) => ({ ...prev, centers: selectedOptions }));
  };
  return (
    <>
      <div
        style={{ padding: "20px", display: "flex", flexDirection: "column" }}
      >
        <h2
          style={{
            fontSize: "24px", // Adjust font size
            fontWeight: "bold", // Bold font weight
            color: "#2D3748", // Dark gray color for text
            textAlign: "center", // Center align text
            marginBottom: "20px", // Space below the header
            letterSpacing: "1px", // Slightly increase letter spacing
            textTransform: "uppercase", // Capitalize the text
            borderBottom: "3px solid #4A90E2", // Add an underline with color
            paddingBottom: "10px", // Padding below the text to separate it from the line
          }}
        >
          IPD Doctor Payout
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.2fr", // 5 equal columns
            gap: "10px",
            marginBottom: "20px",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "skyblue",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
          }}
        >
          {/* Dropdown for Centers */}

          {/* Multi-select for Centers */}
          <Select
            options={centerOptions}
            isMulti
            value={filters?.centers}
            onChange={handleChangeCenter}
            placeholder="All Centers"
            closeMenuOnSelect={false} // Keep menu open when selecting options
            hideSelectedOptions={false} // Don't hide selected options
            getOptionLabel={(e) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <input
                  type="checkbox"
                  checked={filters?.centers?.some(
                    (center) => center.value === e.value
                  )}
                  onChange={() =>
                    handleChange(
                      filters?.centers?.some(
                        (center) => center.value === e.value
                      )
                        ? filters.centers.filter(
                            (center) => center.value !== e.value
                          )
                        : [...(filters?.centers || []), e]
                    )
                  }
                  style={{ marginRight: 10, width: "10%" }}
                />
                {e.label}
              </div>
            )}
            styles={{
              option: (provided) => ({
                ...provided,
                display: "flex",
                alignItems: "center",
              }),
            }}
          />
          {/* Multi-select for Doctors */}
          <Select
            options={doctorOptions}
            isMulti
            value={filters?.doctors}
            onChange={handleChange}
            placeholder="All Doctors"
            closeMenuOnSelect={false} // Keep menu open on selection
            hideSelectedOptions={false} // Don't hide selected options
            getOptionLabel={(e) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <input
                  type="checkbox"
                  checked={filters?.doctors?.some(
                    (doc) => doc.value === e.value
                  )}
                  onChange={() =>
                    handleChange(
                      filters?.doctors?.some((doc) => doc.value === e.value)
                        ? filters.doctors.filter((doc) => doc.value !== e.value)
                        : [...(filters?.doctors || []), e]
                    )
                  }
                  style={{ marginRight: 10, width: "10%" }}
                />
                {e.label}
              </div>
            )}
            styles={{
              option: (provided) => ({
                ...provided,
                display: "flex",
                alignItems: "center",
              }),
            }}
          />
          {/* Start Date Picker */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <label htmlFor="startDate">Start Date</label>
            <input
              type="date"
              name="startDate"
              id="startDate"
              placeholder="Start Date"
              value={filters?.startDate}
              onChange={handleInputChange}
            />
          </div>
          {/* End Date Picker */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <label htmlFor="ed">End Date</label>
            <input
              type="date"
              name="endDate"
              placeholder="End Date"
              value={filters?.endDate}
              onChange={handleInputChange}
            />
          </div>

          <img
            src={searchIcon}
            alt="excel"
            title="Search"
            onClick={fetchData}
            style={{
              width: "24px",
              height: "24px",
              cursor: "pointer",
              border: "2px solid #4A90E2", // Border with color
              borderRadius: "4px", // Optional: rounded corners
              padding: "2px", // Optional: space between image and border
            }}
          />
        </div>
        <div
          style={{
            gridColumn: "span 2",
            textAlign: "center",
            display: "flex",
            alignItems: "end",
            flexGrow: 1,
            justifyContent: "flex-end", // Align to the right
          }}
        >
          <img
            src={exportIcon}
            alt="excel"
            style={{ width: "24px", height: "24px", cursor: "pointer" }}
            title="Export to Excel"
            onClick={handleExport}
          />
          {/* <button
            onClick={handleExport}
            disabled={isLoading}
            style={{
              maxHeight: "50px",
              backgroundColor: "blue", // Green background
              color: "white", // White text
              padding: "10px 20px", // Padding
              border: "none", // Remove border
              borderRadius: "5px", // Rounded corners
              fontSize: "16px", // Font size
              cursor: "pointer", // Pointer cursor on hover
              transition: "background-color 0.3s ease", // Smooth transition for hover effect
            }}
          >
            {isLoading ? "Exporting..." : "Export to Excel"}
          </button> */}
          {/* {isLoading && <span>Loading...</span>} */}
        </div>
        {/* Table for Displaying Data */}
        <DoctorTables
          data={data}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          filters={filters}
          flow={"surgerypackage"}
        />
      </div>
      <div
        className="totalpaymentparent"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          padding: "20px",
          backgroundColor: "#f9fafb",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
          margin: "20px auto",
        }}
      >
        {filters.doctors.length === 1 && (
          <div>
            {/* Net Billing */}
            <div
              className="total-payment"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <label
                className="head-label"
                style={{
                  fontWeight: "600",
                  color: "#003366",
                  fontSize: "16px",
                }}
              >
                Net Billing:
              </label>
              <span
                style={{
                  fontWeight: "600",
                  color: "#4caf50", // Green color for positive numbers
                  fontSize: "16px",
                }}
              >
                {data
                  .reduce(
                    (sum, item) =>
                      sum + parseFloat(item["Total Net Payable"] || 0),
                    0
                  )
                  .toFixed(2)}
              </span>
            </div>

            {/* Payable */}
            <div
              className="total-payment"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <label
                className="head-label"
                style={{
                  fontWeight: "600",
                  color: "#003366",
                  fontSize: "16px",
                }}
              >
                Payable:
              </label>
              <span
                style={{
                  fontWeight: "600",
                  color: "#2196f3", // Blue color for positive numbers
                  fontSize: "16px",
                }}
              >
                {data
                  .reduce((sum, item) => sum + parseFloat(item["Paid"] || 0), 0)
                  .toFixed(2)}
              </span>
            </div>

            {/* Pending Payments */}
            <div
              className="total-payment"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <label
                className="head-label"
                style={{
                  fontWeight: "600",
                  color: "#003366",
                  fontSize: "16px",
                }}
              >
                Pending Payments:
              </label>
              <span
                style={{
                  fontWeight: "600",
                  color: "#f44336", // Red color for pending
                  fontSize: "16px",
                }}
              >
                {data
                  .reduce(
                    (sum, item) => sum + parseFloat(item["Not Paid"] || 0),
                    0
                  )
                  .toFixed(2)}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SurgeyPackage;
